module.exports = __webpack_public_path__ + "assets/certificate_pdf/DUKE_DATAPOWER.9979545b.pdf";